import { Application, Users } from '@platform/client';
import { ApplicationResultContent } from './ApplicationResultContent';
import { Button } from '@platform/components';
import { ROUTES } from '../../routes/consts';
import { Link } from 'wouter';
import { useApplicationLocalStorage } from '../application-hook';
import { ProfessionalApplicationData } from '@platform/client/schemas';
import { ApplicationStorageDataKeys } from '../Application';
import { navigate } from 'wouter/use-browser-location';
import { skillExperienceOptions } from '../skills/SkillsSelection';
import LeftSection from '../images/LeftSection.png';

export const WelcomeBackPage = () => {
  const { data } = Users.useGetCurrentUser();
  // on click start, get and set user app data
  const { data: userAppData } = Application.useGetProfessionalApplicationData();
  const { updateApplicationData: updateUserAppData } =
    useApplicationLocalStorage<ProfessionalApplicationData>(
      ApplicationStorageDataKeys.PROFESSIONAL_APPLICATION,
    );

  const onClick = () => {
    updateUserAppData({
      ...userAppData,
      skills:
        userAppData?.skills?.map((skill) => ({
          skill: skill.skill,
          experience:
            skillExperienceOptions.find((option) => option.label === skill.experience)?.value ??
            skill.experience,
        })) || [],
    });
    navigate(`/platform/application${data?.corporatePartner ? `/${data?.corporatePartner}` : ''}`);
  };
  return (
    <ApplicationResultContent
      title={`Welcome back, ${data?.firstName} 👋`}
      backgroundImage={LeftSection}
      description={
        <div>
          <p className='text-base mb-8'>
            We're glad you're back! Take a moment to review your application and confirm your
            details are still current. You'll see the full cohort timeline before you submit.
          </p>
          <Button variant='primary' size='lg' additionalClassnames='w-full mb-6' onPress={onClick}>
            Review my application
          </Button>
          <div className='text-center'>
            <Link to={ROUTES.DASHBOARD}>Exit</Link>
          </div>
        </div>
      }
    />
  );
};
